@let isMobile = breakpoints() === "mobile";
<section
  class="gallery-layout gallery-layout-3"
  [ngClass]="isBackgroundWhite() ? 'background-white' : 'background-cream'">
  <div class="container">
    @if (title()) {
      <app-title [titles]="[title()]" class="title" />
    }
    <div class="figures">
      @for (item of data().items; track item; let i = $index) {
        <figure #figure [offset]="100" style="--i: {{ i }}" addClass="figure-visible" addClassOnView class="figure">
          @if (item.video) {
            @if (figureWidth()) {
              <app-video
                [mp4Url]="item.video.mp4Url"
                [previewImage]="item?.image"
                [isPlayFullscreen]="true"
                [isResetAfterFullscreen]="true"
                [isHidePosterGoingFullscreen]="true"
                (videoComplete)="onVideoComplete(item.legend, item.url)"
                (videoStart)="onVideoStart(item.legend, item.url)"
                [style]="{ width: isMobile ? figureWidth() : '276px', height: isMobile ? '236px' : '425px' }" />
            }
          } @else {
            @if (item.image; as image) {
              <div>
                <app-image (click)="onClick(item)" [image]="image" [size]="{ dw: 276, dh: 425, mh: 236 }" />
              </div>
            }
          }
          @if (item.legend && item.url) {
            <figcaption>
              <hr class="link-separator" />
              @if (item.surTitle) {
                <div class="subtitle">{{ item.surTitle }}</div>
              }
              @if (item.video) {
                <span [innerHTML]="item.legend" class="link"></span>
              } @else {
                <a [innerHTML]="item.legend" [routerLink]="item.url" class="link"></a>
              }
            </figcaption>
          }
          @if (item.video; as video) {
            <app-button
              class="btn-action"
              (click)="onButtonClick('Voir l\'épisode', item.legend)"
              [icon]="{ name: 'PLAY', position: 'LEFT', size: '16px' }"
              label="Voir l'épisode"
              [size]="isMobile ? 'SMALL' : 'NORMAL'"
              [url]="item.url" />
          }
        </figure>
      }
    </div>
  </div>
</section>
